import Tracking from "../uidispatcherapi/Tracking";
import FeatureSessionStore from "../uidispatcherapi/FeatureSessionStore";
import { METRO_X_ACCOUNT_SELECT } from "../../api/Features";
import { HOOK_SKIPPED } from "./redirectUtil";

const isAccountSelectPage = () => {
	return FeatureSessionStore.getMembershipFor(METRO_X_ACCOUNT_SELECT) === "B";
};

const redirectTier12CustomersHook = (state, sessionStore, handler) => {
	if (isAccountSelectPage()) {
		return HOOK_SKIPPED;
	}

	const tierLevel = sessionStore.getCustomerTierLevel();
	const isTier12 = tierLevel === "1" || tierLevel === "2";

	if (state.routeParams.invisibleForTier12 && isTier12) {
		Tracking.trackStructuredEvent("platform", "uidispatcher", "tierDisallowedAccess", {
			tags: {
				path: state.path,
			},
		});
		handler.transitionTo("/");
		return {
			checkNext: true,
			didRedirect: true,
		};
	}

	return HOOK_SKIPPED;
};

export const RedirectTiers = {
	hook: redirectTier12CustomersHook,
};
